module.exports = __webpack_public_path__ + "static/media/astronauta_1.1f791b23.svg";